import React from 'react';
import { cn } from '../../utils/cn';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...props
}) => {
  const baseStyles = 'font-cairo font-medium transition-all duration-200 flex justify-center items-center gap-2 rounded-md';
  
  const variants = {
    primary: 'bg-[#C97B5A] text-white hover:bg-[#A0522D] shadow-sm',
    secondary: 'bg-white text-Color-Neutral-Darkest hover:bg-gray-100 shadow-sm',
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm sm:px-5 sm:text-base',
    md: 'px-5 py-2.5 text-sm sm:px-6 sm:text-base',
    lg: 'px-10 py-3.5 text-[16px] font-semibold sm:px-8 sm:py-3 sm:text-lg sm:font-medium',
  };
  
  return (
    <button
      className={cn(
        baseStyles,
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};